import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GlobalAlertsConfigurationComponent } from './global-alerts-configuration/global-alerts-configuration.component';
import { MyAlertsConfigurationComponent } from './my-alerts-configuration/my-alerts-configuration.component';

const routes: Routes = [
  {
    path: '',
    component: GlobalAlertsConfigurationComponent
  },
  {
    path: 'global-alerts-configuration',
    loadChildren: () => import('./global-alerts-configuration/global-alerts-configuration.module')
      .then(m => m.GlobalAlertsConfigurationModule)
  },
  {
    path: '',
    component: MyAlertsConfigurationComponent
  },
  {
    path: 'my-alerts-configuration',
    loadChildren: () => import('./my-alerts-configuration/my-alerts-configuration.module')
      .then(m => m.MyAlertsConfigurationModule)
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AlertsConfigurationRoutingModule { }
